import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { notifyBugsnag } from "@/lib/bugsnag";

// Route-level fallback for React Router. RR intercepts errors thrown while
// rendering a route — most commonly a lazy chunk that 404s after a deploy
// (see `lib/lazy-with-reload.ts`, when the guarded reload didn't recover) —
// at the nearest route boundary, and renders its own default "Unexpected
// Application Error!" developer screen unless a route supplies an
// `errorElement`. This is that element, wired at the router root in
// `src/App.tsx`. It mirrors `BugsnagBoundary`'s reload-to-recover fallback so
// the app's two error surfaces read identically.
export function RouteErrorPage() {
  const error = useRouteError();
  useEffect(() => {
    notifyBugsnag(error);
  }, [error]);

  return (
    <section className="section">
      <div className="shell" style={{ textAlign: "center", maxWidth: 540 }}>
        <h1>Ceva nu a mers bine.</h1>
        <p>Am notat eroarea. Reîncearcă — dacă persistă, scrie-ne.</p>
        <button
          type="button"
          className="btn btn--primary btn--lg"
          onClick={() => {
            if (typeof window !== "undefined") window.location.reload();
          }}
        >
          Reîncarcă
        </button>
      </div>
    </section>
  );
}
